// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"b94e3615","440":"15f024de","453":"9ce9b81a","909":"e8fdc1e4","913":"71723467"}[chunkId] + ".chunk.js";
};